import { type JSX, Show } from "solid-js";

// Shared visual primitives for the TOV surface. Cards reuse the dashboard
// `.card` token; bars are TOV-specific (neutral accent fill) and deliberately
// do NOT reuse ThresholdBar, whose poor/watch/good zones imply metric health.

export function CardGrid(props: { children: JSX.Element }) {
  return <div class="tov-grid">{props.children}</div>;
}

export function Card(props: {
  title: string;
  tag?: string;
  children: JSX.Element;
}) {
  return (
    <article class="card tov-card">
      <header class="tov-card-head">
        <span class="tov-card-title">{props.title}</span>
        <Show when={props.tag}>
          <span class="tov-chip">{props.tag}</span>
        </Show>
      </header>
      <div class="tov-card-body">{props.children}</div>
    </article>
  );
}

export function EmptyState(props: { label: string }) {
  return <p class="tov-empty">No {props.label} yet.</p>;
}

const clamp = (value: number) => Math.max(0, Math.min(100, value));

export function StrengthBar(props: { value: number }) {
  return (
    <div class="tov-bar" title={`${props.value} / 100`}>
      <div class="tov-bar-fill" style={{ width: `${clamp(props.value)}%` }} />
    </div>
  );
}

export function RangeBar(props: { min: number; max: number }) {
  const left = () => clamp(props.min);
  const width = () => clamp(props.max) - clamp(props.min);
  return (
    <div class="tov-bar" title={`${props.min}–${props.max}`}>
      <div
        class="tov-bar-span"
        style={{ left: `${left()}%`, width: `${width()}%` }}
      />
    </div>
  );
}
